import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { GetDictionaryList } from 'src/app/Common/common.interface';
import { IndHierarchy_readAll, IndHierarchy_readById, IndHierarchy_readByUserId, IndHierarchy_readByIndId, IndHierarchy_create, IndHierarchy_update, IndHierarchy_delete, IndHierarchy_GetManagerDictionary } from 'src/app/GlobalVariable/ERP.GlobalVariable';
import { IndHierarchyList, IndHierarchyReadByIdRequestDTO, IndHierarchyDTO, IndHierarchyReadByUserIdRequestDTO, IndHierarchyReadByIndIdRequestDTO, IndHierarchyCreateRequestDTO, IndHierarchyUpdateRequestDTO, IndHierarchyDeleteRequestDTO } from './indhierarchy.interface';

@Injectable({
  providedIn: 'root'
})
export class IndHierarchyService {
  constructor(private http: HttpClient) {}

  IndHierarchy_readAll(): Observable<IndHierarchyList> {
    return this.http.get<IndHierarchyList>(IndHierarchy_readAll);
  }

  IndHierarchy_readById(data: IndHierarchyReadByIdRequestDTO): Observable<IndHierarchyDTO> {
    return this.http.post<IndHierarchyDTO>(IndHierarchy_readById, data);
  }

  IndHierarchy_readByUserId(data: IndHierarchyReadByUserIdRequestDTO): Observable<IndHierarchyDTO> {
    return this.http.post<IndHierarchyDTO>(IndHierarchy_readByUserId, data);
  }

  IndHierarchy_readByIndId(data: IndHierarchyReadByIndIdRequestDTO): Observable<IndHierarchyDTO> {
    return this.http.post<IndHierarchyDTO>(IndHierarchy_readByIndId, data);
  }

  IndHierarchy_create(data: IndHierarchyCreateRequestDTO): Observable<IndHierarchyDTO> {
    return this.http.post<IndHierarchyDTO>(IndHierarchy_create, data);
  }

  IndHierarchy_update(data: IndHierarchyUpdateRequestDTO): Observable<IndHierarchyDTO> {
    return this.http.post<IndHierarchyDTO>(IndHierarchy_update, data);
  }

  IndHierarchy_delete(data: IndHierarchyDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(IndHierarchy_delete, data);
  }
  IndHierrachy_GetManagerDictionary(companyId:string, hLevel: string): Observable<GetDictionaryList> {
    return this.http.get<GetDictionaryList>(IndHierarchy_GetManagerDictionary + `?CompanyId=${companyId}&hLevel=${hLevel}`)
  }
}
